import axios from '../../../services/axios';
import { axiosNT, axiosNTL, axiosNL } from '../../../services/axios';
import CommentBody from '../types/CommentBody';

const getComments = (contentId: string, status: string, limit: number, skip: number) => axiosNTL
  .get(`/comment/getComments?contentId=${contentId}&type=${status}&packageId=${contentId}&limit=${limit}&skip=${skip}`)
  .then((res: any) => Promise.resolve(res.responseObject));

const getCommentCount = (contentId: string) => axiosNTL
  .get(`/comment/getCommentCount?contentId=${contentId}`)
  .then((res: any) => Promise.resolve(res.responseObject));

const addComment = (newComment: any) => axios
  .post(`comment/addComment`, newComment)
  .then((res: any) => {
    const comment: CommentBody = res.responseObject;
    return Promise.resolve(comment);
  });

const editComment = (comment: any) => axiosNL
  .put(`comment/editComment`, comment)
  .then((res: any) => {
    const comment: CommentBody = res.responseObject;
    return Promise.resolve(comment);
  });


const changeStatus = (comment: any) => axiosNL
  .patch(`comment/changeStatus`, comment)
  .then((res: any) => {
    const comment: CommentBody = res.responseObject;
    return Promise.resolve(comment);
  });

const replyComment = (replyComment: any) => axiosNL
  .post(`comment/replyComment`, replyComment)
  .then((res: any) => {
    const comment: CommentBody = res.responseObject;
    return Promise.resolve(comment);
  });

const deleteComment = (commentId: string) => axiosNL
  .delete(`comment/deleteComment/${commentId}`)
  .then((res: any) => {
    const deletedComment: any = res.responseObject.data.nModified && res.responseObject.data.nModified > 0 ? true : false;
    return Promise.resolve(deletedComment);
  });


export default {
  getComments,
  addComment,
  getCommentCount,
  replyComment,
  deleteComment,
  editComment,
  changeStatus
};